import { makeStyles } from "@material-ui/styles";
import Commons from "../../../utils/styles";
import { colors } from "../../../styleguide";

const styles = makeStyles({
  container: {
    position: "relative",
    backgroundColor: colors.white,
    width: "100vw",
    padding: 12,
    boxSizing: "border-box",
    [Commons.smallQuery]: {
      padding: 6,
    },
  },
  header: {
    ...Commons.flexRow,
    backgroundColor: colors.black,
    borderRadius: "24px 24px 0 0",
    padding: "6px 48px",
    gap: 18,
    width: "100%",
    boxSizing: "border-box",
    [Commons.midQuery]: {
      padding: "6px 24px",
    },
    [Commons.smallQuery]: {
      padding: "6px 12px",
    },
  },
  logo: {
    height: 66,
    width: "auto",
    [Commons.smallQuery]: {
      height: 48,
    },
  },
  blank: {
    flex: 1,
  },
  button: {
    ...Commons.defaultButton,
    backgroundColor: "transparent",
    padding: "12px 24px",
    color: colors.white,
    textAlign: "center",
    fontWeight: 600,
    fontSize: 18,
    transition: "all 0.2s",
    textDecoration: "none",
    "&:hover": {
      opacity: 0.75,
    },
    [Commons.midQuery]: {
      display: "none",
    },
  },
  containedButton: {
    ...Commons.defaultButton,
    backgroundColor: colors.orange,
    borderRadius: 12,
    padding: "12px 24px",
    color: colors.white,
    textAlign: "center",
    fontWeight: 700,
    fontSize: 18,
    transition: "all 0.2s",
    textDecoration: "none",
    "&:hover": {
      opacity: 0.75,
    },
    [Commons.smallQuery]: {
      padding: "6px 12px",
      fontSize: 14,
    },
  },
  banner: {
    ...Commons.flexCenter,
    flexDirection: "column",
    minHeight: "75vh",
    backgroundColor: colors.black,
    marginTop: 3,
    borderRadius: "0 0 24px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
  },
  videoBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    "& video": {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 0,
      objectFit: "cover",
    },
    "& div": {
      position: "relative",
      zIndex: 1,
      width: "100%",
      height: "100%",
      backgroundImage: "linear-gradient(to top, #000000, transparent)",
    },
  },
  infoBanner: {
    width: "75%",
    position: "relative",
    [Commons.smallQuery]: {
      width: "90%",
      textAlign: "center",
    },
  },
  title: {
    color: colors.white,
    textAlign: "left",
    fontSize: 60,
    margin: 0,
    fontWeight: 700,
    [Commons.midQuery]: {
      fontSize: 48,
    },
    [Commons.smallQuery]: {
      fontSize: 30,
      textAlign: "center",
    },
  },
  description: {
    color: colors.white,
    textAlign: "left",
    fontSize: 36,
    margin: 0,
    fontWeight: 500,
    [Commons.midQuery]: {
      fontSize: 30,
    },
    [Commons.smallQuery]: {
      textAlign: "center",
      fontSize: 18,
      marginTop: 12,
    },
  },
  bannerCta: {
    ...Commons.defaultButton,
    backgroundColor: colors.orange,
    color: colors.white,
    borderRadius: 12,
    textAlign: "center",
    fontWeight: 600,
    fontSize: 18,
    padding: "12px 24px",
    marginTop: 24,
    [Commons.smallQuery]: {
      fontSize: 14,
    },
  },
  services: {
    ...Commons.flexRow,
    flexWrap: "wrap",
    gap: 18,
    margin: "42px 0",
    width: "100%",
    justifyContent: "center",
  },
  cardService: {
    borderRadius: 18,
    overflow: "hidden",
    padding: 24,
    width: "calc(25% - 18px)",
    boxSizing: "border-box",
    minHeight: 360,
    position: "relative",
    color: colors.black,
    "& svg": {
      fontSize: 42,
      position: "relative",
    },
    [Commons.midQuery]: {
      width: "calc(33.33% - 18px)",
    },
    [Commons.smallQuery]: {
      width: "100%",
      minHeight: 300,
    },
    "&:hover": {
      color: colors.white,
      "& div.primary": {
        backgroundImage: `linear-gradient(to bottom, ${colors.primary}, 75%,transparent)`,
        opacity: 1,
      },
      "& div.secondary": {
        backgroundImage: `linear-gradient(to bottom, ${colors.secondary}, 75%,transparent)`,
        opacity: 1,
      },
      "& div.pink": {
        backgroundImage: `linear-gradient(to bottom, ${colors.pink}, 75%,transparent)`,
        opacity: 1,
      },
      "& div.blue": {
        backgroundImage: `linear-gradient(to bottom, ${colors.blue}, 75%,transparent)`,
        opacity: 1,
      },
      "& div.gray": {
        backgroundImage: `linear-gradient(to bottom, ${colors.blackLight}, 75%,transparent)`,
        opacity: 1,
      },
      "& a": {
        display: "inline",
      },
      "& img": {
        opacity: 1,
      },
    },
  },
  bgCardService: {
    position: "absolute",
    zIndex: 0,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `linear-gradient(to bottom, ${colors.blackLight}, 25%, transparent)`,
    transition: "all 0.2s",
    opacity: 0.5,
    "&.primary": {
      backgroundImage: `linear-gradient(to bottom, ${colors.primary}, 25%,transparent)`,
    },
    "&.secondary": {
      backgroundImage: `linear-gradient(to bottom, ${colors.secondary}, 25%,transparent)`,
    },
    "&.pink": {
      backgroundImage: `linear-gradient(to bottom, ${colors.pink}, 25%,transparent)`,
    },
    "&.blue": {
      backgroundImage: `linear-gradient(to bottom, ${colors.blue}, 25%, white)`,
    },
  },
  imgBgCardService: {
    position: "absolute",
    zIndex: 0,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: 0,
    transition: "all 0.6s",
  },
  nameService: {
    fontWeight: 700,
    fontSize: 24,
    margin: "12px 0",
    position: "relative",
  },
  descriptionService: {
    fontWeight: 500,
    fontSize: 18,
    margin: 0,
    position: "relative",
    marginBottom: 24,
  },
  buttonService: {
    ...Commons.defaultButton,
    backgroundColor: colors.white,
    borderRadius: 12,
    padding: "6px 12px",
    color: colors.black,
    textAlign: "center",
    fontWeight: 700,
    fontSize: 18,
    transition: "all 0.2s",
    textDecoration: "none",
    position: "relative",
    display: "none",
    "&:hover": {
      opacity: 0.75,
    },
    [Commons.smallQuery]: {
      display: "inline",
    },
  },
  footer: {
    width: "100$",
    boxSizing: "border-box",
    borderRadius: "0 0 18px 18px",
    overflow: "hidden",
  },
});

export default styles;
